module.exports = __webpack_public_path__ + "static/media/como-funciona-ico-2-sel.036fd60d.svg";